
export default {
  name: 'RedirectPage',
  layout: 'fullscreen',
  auth: false,
  mounted() {
    if (!this.$auth.loggedIn) {
      this.$auth.loginWith('keycloak', {
        params: {
          'connection': this.$route.query.connection,
          'screen_hint': this.$route.query.screen_hint || 'login',
        },
      })
    } else {
       this.$router.push(this.localePath('/features'))
    }
    this.$gtag?.event('redirect')
  },
}
